
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/journeys",
      function () {
        return require("private-next-pages/native-delivery/journeys.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/journeys"])
      });
    }
  